module.exports = __webpack_public_path__ + "static/10-9efdb58276eda1935abdcec061506033.png";